export const REGISTRATION_SUCCESS_NOTICE_KEY = "mfp_registration_success_notice";

export const REGISTRATION_SUCCESS_NOTICE =
  "Account created successfully. You can sign in below. Check your email for a verification message if required.";

export const writeRegistrationSuccessNotice = () => {
  try {
    window.sessionStorage.setItem(
      REGISTRATION_SUCCESS_NOTICE_KEY,
      REGISTRATION_SUCCESS_NOTICE
    );
    return null;
  } catch (error) {
    return {
      state: {
        registrationSuccessNotice: REGISTRATION_SUCCESS_NOTICE,
      },
    };
  }
};

export const consumeRegistrationSuccessNotice = (locationState = {}) => {
  try {
    const storedNotice = window.sessionStorage.getItem(REGISTRATION_SUCCESS_NOTICE_KEY);
    if (storedNotice) {
      window.sessionStorage.removeItem(REGISTRATION_SUCCESS_NOTICE_KEY);
      return storedNotice;
    }
  } catch (error) {}

  return locationState?.registrationSuccessNotice || "";
};
